import { useState } from 'react';

const API_URL = import.meta.env.VITE_API_URL || 'https://t4ssg2rzr3.execute-api.eu-west-1.amazonaws.com/FirstDeploy/healthai';

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [submitStatus, setSubmitStatus] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitStatus('Sending...');

    const data = {
      type: 'emailForm',
      ...formData,
      for_service: 'healthai'
    };

    try {
      if (!API_URL) {
        throw new Error('API URL is not configured');
      }

      console.log('Attempting to send to:', API_URL);
      console.log('With data:', data);

      const response = await fetch(API_URL, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Origin': window.location.origin
        },
        mode: 'cors',
        credentials: 'omit',
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        const errorText = await response.text().catch(() => 'No error text available');
        console.error('Server response:', errorText);
        console.error('Response status:', response.status);
        console.error('Response headers:', Array.from(response.headers.entries()));
        throw new Error(`Request failed with status code: ${response.status}. ${errorText}`);
      }

      const result = await response.json();
      console.log("Success Response:", result);
      setSubmitStatus('Form submitted successfully!');
      setFormData({ name: '', email: '', message: '' });
    } catch (error) {
      console.error('Detailed error:', error);
      let errorMessage = 'Failed to submit form. Please try again.';
      
      if (error instanceof Error) {
        if (error.message.includes('Failed to fetch')) {
          errorMessage = 'Unable to reach the server. Please check your internet connection and try again.';
        } else {
          errorMessage = error.message;
        }
      }
      
      setSubmitStatus(errorMessage);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <label htmlFor="name" className="block text-sm font-semibold leading-6 text-gray-900">
          Name
        </label>
        <div className="mt-2.5">
          <input
            type="text"
            name="name"
            id="name"
            value={formData.name}
            onChange={handleChange}
            autoComplete="name"
            required
            className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
          />
        </div>
      </div>
      <div>
        <label htmlFor="email" className="block text-sm font-semibold leading-6 text-gray-900">
          Email
        </label>
        <div className="mt-2.5">
          <input
            type="email"
            name="email"
            id="email"
            value={formData.email}
            onChange={handleChange}
            autoComplete="email"
            required
            className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
          />
        </div>
      </div>
      <div>
        <label htmlFor="message" className="block text-sm font-semibold leading-6 text-gray-900">
          Message
        </label>
        <div className="mt-2.5">
          <textarea
            name="message"
            id="message"
            value={formData.message}
            onChange={handleChange}
            rows={4}
            required
            className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
          />
        </div>
      </div>
      <div>
        <button
          type="submit"
          disabled={submitStatus === 'Sending...'}
          className="block w-full rounded-full bg-primary px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-primary-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {submitStatus === 'Sending...' ? 'Sending...' : 'Send Message'}
        </button>
      </div>
      {submitStatus && (
        <p className={`mt-4 text-sm ${submitStatus.includes('Failed') ? 'text-red-600' : 'text-green-600'}`}>
          {submitStatus}
        </p>
      )}
    </form>
  );
} 